export function getFontLanguage(_country: string, _language: string) {
  const country = _country.toUpperCase()
  const language = _language.toLowerCase()
  /**
   * Get the font language code for IKEA font loading.
   * Handles Chinese variants with proper script extensions.
   *
   * @author S1
   */
  if (language === 'zh') {
    // Simplified Chinese (mainland China, Singapore)
    if (country === 'CN' || country === 'SG') {
      return 'zh-Hans'
    }
    // Traditional Chinese (Taiwan, Hong Kong)
    if (country === 'TW' || country === 'HK') {
      return 'zh-Hant'
    }
    // Default to simplified
    return 'zh-Hans'
  }

  return language
}
